var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.25 0.6875H2.75C1.61 0.6875 0.6875 1.61 0.6875 2.75V7.25C0.6875 8.39 1.61 9.3125 2.75 9.3125H13.25C14.39 9.3125 15.3125 8.39 15.3125 7.25V2.75C15.3125 1.61 14.39 0.6875 13.25 0.6875ZM2.75 1.8125H3.545C3.6275 1.985 3.6875 2.1725 3.6875 2.375C3.6875 3.095 3.095 3.6875 2.375 3.6875C2.1725 3.6875 1.985 3.6275 1.8125 3.545V2.75C1.8125 2.2325 2.2325 1.8125 2.75 1.8125ZM1.8125 7.25V4.7375C1.9925 4.7825 2.18 4.8125 2.375 4.8125C3.7175 4.8125 4.8125 3.7175 4.8125 2.375C4.8125 2.18 4.7825 1.9925 4.7375 1.8125H13.25C13.7675 1.8125 14.1875 2.2325 14.1875 2.75V5.2625C14.0075 5.2175 13.82 5.1875 13.625 5.1875C12.2825 5.1875 11.1875 6.2825 11.1875 7.625C11.1875 7.82 11.2175 8.0075 11.2625 8.1875H2.75C2.2325 8.1875 1.8125 7.7675 1.8125 7.25ZM13.25 8.1875H12.455C12.3725 8.015 12.3125 7.8275 12.3125 7.625C12.3125 6.905 12.905 6.3125 13.625 6.3125C13.8275 6.3125 14.015 6.3725 14.1875 6.455V7.25C14.1875 7.7675 13.7675 8.1875 13.25 8.1875Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 2.9375C6.86 2.9375 5.9375 3.86 5.9375 5C5.9375 6.14 6.86 7.0625 8 7.0625C9.14 7.0625 10.0625 6.14 10.0625 5C10.0625 3.86 9.14 2.9375 8 2.9375ZM8 5.9375C7.4825 5.9375 7.0625 5.5175 7.0625 5C7.0625 4.4825 7.4825 4.0625 8 4.0625C8.5175 4.0625 8.9375 4.4825 8.9375 5C8.9375 5.5175 8.5175 5.9375 8 5.9375Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentTab);
export default __webpack_public_path__ + "static/media/payment-tab.d948a72bb3259aad4310f834e7677f51.svg";
export { ForwardRef as ReactComponent };